import { render, staticRenderFns } from "./OverviewNonScheduledProducts.vue?vue&type=template&id=4c938d96&scoped=true&lang=pug&"
import script from "./OverviewNonScheduledProducts.vue?vue&type=script&lang=js&"
export * from "./OverviewNonScheduledProducts.vue?vue&type=script&lang=js&"
import style0 from "./OverviewNonScheduledProducts.vue?vue&type=style&index=0&id=4c938d96&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c938d96",
  null
  
)

export default component.exports